/**
 * Choice menu component.
 *
 * Renders available choice options as a vertical stack of buttons.
 * P1a: plain buttons, no styling beyond legibility.
 */

import type { ChoiceOption } from "../engine/EventBus";

interface ChoiceMenuProps {
  options: ChoiceOption[];
  onSelect: (index: number) => void;
}

export function ChoiceMenu({ options, onSelect }: ChoiceMenuProps) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "2rem",
        left: "50%",
        transform: "translateX(-50%)",
        width: "min(80%, 720px)",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
      }}
    >
      {options.map((opt) => (
        <button
          key={opt.index}
          onClick={() => onSelect(opt.index)}
          style={{
            padding: "1rem 1.5rem",
            background: "rgba(0, 0, 0, 0.85)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            borderRadius: "6px",
            color: "#eee",
            fontSize: "1rem",
            cursor: "pointer",
            textAlign: "left",
            transition: "border-color 0.15s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.7)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.3)";
          }}
        >
          {opt.menu}
        </button>
      ))}
    </div>
  );
}
